module.exports = __webpack_public_path__ + "static/media/YF21_0.7d961073.jpg";